<template>
     <div class="main-content" id="panel">
      <router-view></router-view>
    </div>
</template>
<script>
export default {
  name: "BA",
  components: {
  },
  data() {
    return {
      
    };
  },
  methods: {
    
  },
  mounted() {
   
  }
};
</script>